// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_container.widget-file{height:auto !important}.image_container.widget-file img{cursor:pointer !important}`, "",{"version":3,"sources":["webpack://./src/shared/components/ncTable/NcTable.vue"],"names":[],"mappings":"AACA,6BACC,sBAAA,CAGD,iCACC,yBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
